<template>
    <div>
        <el-card style="margin-bottom: 30px;" class="box-card" v-for="item in allorder">
            <p class="myOrder-number">
                <i class="el-icon-tickets"></i>订单编号：{{item.ordernub}}
                <span class="date">{{item.creationTime | formattime}}</span>  <a
                    href="javascript:void(0);" target="_blank" class="r">我要反馈</a>
            </p>
            <indentlist v-bind:indentid="item.indentid"/>
            <div class="pay-box clearfix">
                <div class="goods-total-price-box clearfix">
                    <p class="r rw price-num">
                        <em>￥</em><span id="js-actual-price">{{item.price | formats}}</span>
                    </p>
                    <p class="r price-text">共 <span>{{item.buynubr}}</span> 件商品，商品总金额：</p>
                </div>
                <div class="r" v-if="!item.ispaid">
                    <a href="javascript:void(0);" @click="submitOrder(item.ordernub)" style="display:block;"
                       class="moco-btn-red submit-btn js-pay-submit"
                    >立即支付</a>
                    <a class="order-cancel submit-btn" @click="delorder(item._id)" href="javascript:void(0);">取消订单</a>
                </div>
                <div class="r" v-if="item.ispaid">
                    <a href="javascript:void(0);" style="display:block;"
                       class="submit-okbtn js-pay-submit"
                    >支付完成</a>

                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import Indentlist from "./indentlist";
    import axios from 'axios';
    import moment from "moment"
    export default {
        props: ["operation"],
        components: {Indentlist, axios},
        name: "orderlist",
        data() {
            return {
                allorder: [],
            }
        },
        methods: {
            //立即支付订单
            submitOrder(data) {
                this.$router.push({
                    name: 'Payfortheorder',
                    params: {
                        id: data
                    }
                })
            },
            delorder(data){
                this.$confirm("您确定要取消订单？?", '取消订单', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post("/Api/admin/delorder", {"id": data}).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除订单成功',
                                    type: 'success',
                                    duration: 10000
                                });
                                this.getAllOrderlist();
                            } else if (res.data.errcode == 40000) {
                                location.reload();
                            } else {
                                //操作失败
                                this.$message({
                                    showClose: true,
                                    message: '删除失败，请重试！',
                                    type: 'error',
                                    duration: 10000
                                });
                            }

                        } else {
                            //操作失败
                            this.$message({
                                showClose: true,
                                message: '删除失败，请重试！！！',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    });
                }).catch(() => {

                });
            },
            getAllOrderlist(){
                axios.post("/Api/admin/getAllOrderlist").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.allorder = res.data.data;
                        } else if (res.data.errcode == 40000) {
                            this.$router.push({
                                name: 'Cart',
                            });
                        }
                    }
                });
            },
            getNoneOrderlist(){
                axios.post("/Api/admin/getNoneOrderlist").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.allorder = res.data.data;
                        } else if (res.data.errcode == 40000) {
                            this.$router.push({
                                name: 'Cart',
                            });
                        }
                    }
                });
            },
            getOkOrderlist(){
                axios.post("/Api/admin/getOkOrderlist").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.allorder = res.data.data;
                        } else if (res.data.errcode == 40000) {
                            this.$router.push({
                                name: 'Cart',
                            });
                        }
                    }
                });
            },
        },
        mounted() {
            //获取所有的
            if (this.operation == 'all') {
              this.getAllOrderlist();
            } else if (this.operation == 'none'){
                this.getNoneOrderlist();
            }else if (this.operation == 'ok'){
                this.getOkOrderlist();
            }
        },
        filters: {  //数据过滤器
            formats: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return value + ".00";
                }
                _val = value.split('.');
                return _val[0] + '.' + _val[1];
            },
            formattime: function (value) {
                return moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
            }
        }
    }
</script>

<style>
    .myOrder-number {
        padding: 28px 0 19px;
        font-weight: 700;
        color: #4d555d;
        border-bottom: 1px solid #b7bbbf;
        font-size: 12px;
        line-height: 12px;
        box-sizing: border-box;
    }

    .myOrder-number i {
        float: left;
        margin-top: -2px;
        margin-right: 10px;
        font-size: 16px;
        color: #f01414;
    }

    .myOrder-number a, .myOrder-number span {
        color: #93999f;
        font-weight: 500;
        margin-left: 24px;
    }

    .order-cancel {
        color: #93999f;
        display: block;
        font-size: 12px;
        line-height: 12px;
    }
    .pay-box .submit-okbtn {
        padding: 0;
        width: 140px;
        height: 40px;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        background-color: #05ff00;
    }
</style>